import { render, staticRenderFns } from "./NextLessonsView.vue?vue&type=template&id=3df89df1&"
import script from "./NextLessonsView.vue?vue&type=script&lang=ts&"
export * from "./NextLessonsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports